import { Injectable } from '@angular/core';
import { HttpService } from '../../core/http/http.service';

import { SmsResponse } from '../models/sms-response.model';
import { UserRegistrationRoutes } from '../constants/user-registration.api-routes-constant';

@Injectable({
  providedIn: 'root',
})
export class UserRegistrationService {

  updatePassWord(guid: any, password: any) {
    return this.http.post(UserRegistrationRoutes.changePassword + '/' + guid, { password: password });
  }

  constructor(private http: HttpService) { }

  validate(guid: string) {
    return this.http.getResponse(`${UserRegistrationRoutes.validate}/${guid}`);
  }

  verify(guid: string, details: { mobileNumber: string}) {
    return this.http.post(UserRegistrationRoutes.verify + '/' + guid, details);
  }

  forgotPassVerify(details: { mobileNumber: string }) {
    return this.http.post(UserRegistrationRoutes.forgotpassverify, details);
  }

  otpVerify(guid: string, tokenCode: string) {
    return this.http.post(UserRegistrationRoutes.otpVerify(guid, tokenCode));
  }

  redirectingUrl(guid: string, details: { paymentUrl: string }) {
    return this.http.post(`${UserRegistrationRoutes.redirectingPaymentGateWay}/${guid}`, details);
  }

  getInfo(identifier: string) {
    return this.http.get(UserRegistrationRoutes.getUser(identifier));
  }

  resendOtp(identifier: string) {
    return this.http.get<SmsResponse>(UserRegistrationRoutes.resentOtp(identifier));
  }

  saveCustomAmount(details: { orderReferenceNo: string, paymentAmount: number, identifier: string }) {
    return this.http.post(`${UserRegistrationRoutes.savecustomamount}/${details.identifier}`, details);
  }
}
